import { animationsList, fadeIn, fadeOut, transformIn, transformOut, expandHeight, collapseHeight, expandWidth, collapseWidth } from "./_animations.mjs"; // import the animations from our animations script so the disclosure script can use them when toggling elements on the page
import { Disclosure } from './_disclosure.mjs';

// todo: this widget REQUIRES that _disclosure.mjs is loaded in first. Without _disclosure.mjs, this script will NOT WORK
// todo: when no data-disclosure-animate is set with no value, it should implicitly be set to "slide" for accordions
//todo: allow for more specific grouping of disclosure elements
// todo: we could implement home/end/arrow key support, but it's optional and not required. Navigates between the accordion headers, optionally in a loop.

// Javascript-Powered Accordion script for the displaying and hiding of elements within an accordion widget, and update their corresponding accordion headers
// @author Jesse de Vries

// How to use:
// Relies on 'disclosure' to work. Import this script after _disclosure.mjs in your app.js.
// accordion headers require [data-disclosure-control], while accordion panels require [data-disclosure-content] to be applied to them
// _disclosure.mjs describes further instructions for the further customization individual accordion items
// place the .js-accordion class on the parent element (IMPORTANT: DO NOT USE CSS WITH THIS CLASS!)
// on .js-accordion, optionally provide the 'stayopen' class to disable the accordion behavior described by fireEvent(). This is a band-aid fix, though. Ideally you should not include the class '.js-accordion' for accordions that do not require the closing of other content

// todo: implement arrow and home/end controls for accordions

    'use strict';

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)'); //todo: We already declare this in _disclosure.mjs

    /**
     * Accordion
     * @author Jesse de Vries
    */
    function Accordion(options) {
        this.Init(options);
    }

    Accordion.prototype = {

        /**
         * Constructor
         * @Param object options
         * @return void
         */
        // Initialize Object variables
        Init: function (options) { // Initialization

            // Default selectors
            this.options = Object.assign({
                controls: '.js-accordion-header', // Controls (buttons) used to toggle elements. The reason we need to assign this is that we only want accordion headers to implement accordion-like behavior. This way regular disclosure controls nested inside an accordion still work as intended. Keep in mind that both regular disclosure controls and accordion headers still need [data-disclosure-control] applied to them
            }, options);

            // Initialize Prototype variables
            this.controls = document.querySelectorAll(this.options.controls);

            this.SetEvents();
        },

        /**
         * SetEvents
         * @return void
         */
        // Event Handling
        SetEvents: function () {

            // Create local variables from the Object context
            const controls = this.controls;
            // todo: should this be debounced?
            controls.forEach(function(control) { // Iterate through all .js-accordion-header elements
                control.addEventListener('click', function() { // todo: consider using Event delegation here
                    fireEvent(this); // Jump to 'fireEvent', passing with it the instance of the button that was clicked and its type as arguments
                });
            });

            function fireEvent(control) {

                const accordion = control.closest('.js-accordion'); // Get the nearest '.js-accordion' parent

                //If the Accordion has the class 'stayopen', or if no .js-accordion parent class is found, don't close the other accordion items
                if (accordion.classList.contains('stayopen') || !accordion) {
                    return;
                }

                // Get all opened accordion panels whose id does not match with the aria-controls attribute of the clicked accordion header // todo: We don't have to worry about looping through multiple aria-controls attributes here because accordion headers can never open more than 1 item at a time, but we should probably throw a warning for headers that have more than 1 string anyway
                const otherContents = accordion.querySelectorAll('.js-accordion-panel[data-disclosure-content=open]:not([id="' + control.getAttribute('aria-controls') + '"])');

                otherContents.forEach(function(otherContent) { // Iterate through all non-matching accordion items
                    otherContent.setAttribute('data-disclosure-content', 'closed'); // Update their states to 'closed'

                    let animation = otherContent.getAttribute('data-animate');

                    if (!animation) {
                        let parentElement = otherContent.closest('[data-animate]');
                        if (parentElement) {
                            animation = parentElement.getAttribute('data-animate');
                        }
                    }

                    Disclosure.prototype.SetAnimation.call(Disclosure.prototype, otherContent, animation);

                });

            }
        }
    }

    export { Accordion };